module.exports = __webpack_public_path__ + "img/verpacken.1f85839.svg";